import React from "react";
import { Helmet } from "react-helmet-async";
import { SOCIAL_IMAGE } from "../lib/seo";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-5xl mx-auto px-6 py-16">
      {/* Without this the page inherited the site-wide title and had no
          canonical at all, which is how it ended up crawled but unindexed.
          Trailing slash matches what Apache actually serves. */}
      <Helmet>
        <title>Privacy Policy | Savorka Solar</title>
        <meta
          name="description"
          content="How Savorka Solar collects, uses and safeguards the information you share when you visit our website."
        />
        <link rel="canonical" href="https://www.savorka.in/privacy-policy/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Privacy Policy | Savorka Solar" />
        <meta
          property="og:description"
          content="How Savorka Solar collects, uses and safeguards the information you share when you visit our website."
        />
        <meta property="og:url" content="https://www.savorka.in/privacy-policy/" />
        <meta property="og:image" content={SOCIAL_IMAGE} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content={SOCIAL_IMAGE} />
      </Helmet>

      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

      <p className="text-gray-600 mb-4">
        Savorka Solar is committed to protecting your privacy. This Privacy
        Policy explains how we collect, use, and safeguard your information
        when you visit our website.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        Information We Collect
      </h2>
      <p className="text-gray-600 mb-4">
        We may collect personal information such as your name, email address,
        phone number, and other details when you fill out forms or subscribe to
        our newsletter on our website.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        How We Use Your Information
      </h2>
      <p className="text-gray-600 mb-4">
        The information we collect may be used to respond to inquiries, improve
        our services, send newsletters or updates, and enhance the overall user
        experience on our website.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        Data Protection
      </h2>
      <p className="text-gray-600 mb-4">
        We take appropriate security measures to protect your personal
        information against unauthorized access, alteration, disclosure, or
        destruction.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        Third-Party Services
      </h2>
      <p className="text-gray-600 mb-4">
        Our website may contain links to third-party websites. We are not
        responsible for the privacy practices or content of those sites.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        Contact Us
      </h2>
      <p className="text-gray-600">
        If you have any questions regarding this Privacy Policy, please contact
        Savorka Solar through our contact page.
      </p>
    </div>
  );
};

export default PrivacyPolicy;